import { StorageInfoTaskDTO } from 'business/models/Models';
import StorageInfoService from 'business/services/StorageInfoService';
import connectionHubManager from 'connectionHub/connectionHubManager';
import RMHub from 'connectionHub/RMHub';
import { useCallback, useEffect, useState } from 'react';

interface StorageInfoProps {
  selectedNodesIds: number[];
  jobId: string;
}

const storageInfoService = new StorageInfoService();

const useStorageInfo = ({ selectedNodesIds, jobId }: StorageInfoProps) => {
  const [connection, setConnection] = useState<RMHub | null>();

  const [storageInfoResult, setStorageInfoResult] = useState<any[]>([]);
  const [databaseSize, setDatabaseSize] = useState<string>('');
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    const setupConnection = async () => {
      const conn = await connectionHubManager.getConnection(
        'progresshub',
        '/progressHub',
      );
      setConnection(conn);
    };
    setupConnection();
  }, []);

  const fetchStorageInfo = useCallback(async () => {
    const request = new StorageInfoTaskDTO();
    request.id = jobId;
    request.taskName = 'StorageInfoTask';
    request.treeNodeIds = selectedNodesIds;

    try {
      await storageInfoService.getStorageInfo(request);
      const dbSize = await storageInfoService.getDatabaseSize();
      setDatabaseSize(dbSize);
    } catch (error) {
      console.error('Failed to fetch storage info: ', error);
    }
  }, [selectedNodesIds]);

  useEffect(() => {
    if (!connection) {
      return;
    }
    fetchStorageInfo();
  }, [fetchStorageInfo, connection]);

  useEffect(() => {
    if (!connection) {
      return;
    }

    const handleUpdateJobProgress = (data: any) => {
      if (
        data &&
        data.jobId === jobId &&
        data.dataObj.rowId === selectedNodesIds.join(', ')
      ) {
        setStorageInfoResult((prev) => [...prev, data.dataObj]);
        setProgress(data.progress);
      }
    };

    connection.on('UpdateJobProgress', handleUpdateJobProgress);

    return () => {
      setStorageInfoResult([]);
      setProgress(0);
      if (connection) {
        connection.off('UpdateJobProgress', handleUpdateJobProgress);
      }
    };
  }, [selectedNodesIds, connection]);

  return { storageInfoResult, databaseSize, progress };
};

export default useStorageInfo;
